module.exports = __webpack_public_path__ + "img/home-cib.47c4e3b9.svg";